


export type Roles = 'Admin';

export const Roles = {
    Admin: 'Admin' as Roles
};

